module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-pt-PT.9349687d.jpg";